<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
  <!-- Background Overlay -->
  <div class="fixed inset-0 bg-[#363738] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]"></div>
  <div class="fixed inset-0 overflow-hidden">
    <div class="absolute inset-0 overflow-hidden">
      <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
        <div class="w-screen max-w-xl px-4 py-4">
          <!-- Modal Content -->
          <div class="flex flex-col overflow-y-auto px-4 py-4">
            <div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
              <!-- Background Overlay -->
              <div
                class="fixed inset-0 bg-[#D4D7DE] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]">
              </div>
              <div class="fixed inset-0 overflow-hidden">
                <div class="absolute inset-0 overflow-hidden">
                  <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
                    <div class="w-screen max-w-6xl p-4">
                      <!-- Modal Container -->
                      <div
                        class="flex h-full flex-col overflow-y-auto rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">
                        <div class="border-b border-zinc-200 px-4 py-2 dark:border-white/10">
                          <div class="flex items-center justify-between">
                            <h3 class="heading" id="slide-over-title">
                              {{ memberId ? 'Edit Member' : 'Add Member' }}
                            </h3>
                            <div class="ml-3 flex h-7 items-center space-x-4">
                              <button (click)="closeModal()"
                                class="rounded-md bg-white text-zinc-500 hover:text-zinc-700 focus:ring-2 focus:ring-primary dark:bg-white/5 dark:text-white dark:hover:text-zinc-300"
                                type="button">
                                <span class="sr-only">Close panel</span>
                                <svg aria-hidden="true" class="h-6 w-6" fill="none" stroke="currentColor"
                                  stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="flex-1 flex flex-col bg-main-base-100 overflow-hidden">
                          <div class="flex-1 grid lg:grid-cols-3 gap-4 overflow-y-auto">
                            <app-add-member [memberId]="memberId" [source]="source" [showHeading]="false"
                              (onSaveMember)="onSaveMember($event)" (onCloseModal)="closeModal($event)"
                              class="lg:col-span-3"></app-add-member>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>